import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Paragraph } from '@scentregroup/ui'
import classNames from 'classnames'
import { imageType } from '../../../types'
import PotentialLink from '../../../components/potential-link'
import Trackable from '../../../components/trackable'
import ResponsiveImage from '../../../components/responsive-image'
import ArticleHeading from '../../../components/article/article-heading'
import IconRow from '../../../components/icon-row'
import { capitalize } from '../../../helpers'
import { trackingActions, trackingTypes } from '../../../constants'
import style from './index.scss'
import optus from './assets/optus.svg'
import vodafone from './assets/vodafone.svg'

const brandAsset = {
  optus,
  vodafone,
}

const Sponsor = ({
  link,
  image,
  heading,
  location,
  body,
  brand,
  analyticsMetadata,
}) => (
  <Fragment>
    <Trackable
      {...analyticsMetadata}
      trackingAction={trackingActions.viewPromotion}
      type={trackingTypes.promotion}
    >
      <div className={style.brand}>
        <img
          src={brandAsset[brand]}
          className={style.logo}
          alt={`Powered by ${capitalize(brand)}`}
        />
      </div>
      <div className={style.container}>
        <div className={style.imageWrapper}>
          <PotentialLink link={link}>
            <ResponsiveImage
              desktopImageUrl={image.src}
              mobileImageUrl={image.src}
              mobileRatio="square"
              desktopRatio="square"
              numberOfItems={3}
              alt={image.alt}
            />
          </PotentialLink>
        </div>
        <div className={classNames(style.inner, style.articleHeading)}>
          <ArticleHeading type="large" link={link}>
            {heading}
          </ArticleHeading>
          {location && (
            <IconRow
              text={location}
              icon="location-drop-pin"
              className={style.location}
            />
          )}
          <Paragraph type="medium" className={style.summary}>
            {body}
          </Paragraph>
        </div>
      </div>
    </Trackable>
  </Fragment>
)

Sponsor.propTypes = {
  link: PropTypes.string,
  image: imageType.isRequired,
  heading: PropTypes.string.isRequired,
  location: PropTypes.string,
  body: PropTypes.string,
  brand: PropTypes.oneOf(['optus', 'vodafone']),
  analyticsMetadata: PropTypes.shape({
    correlationId: PropTypes.string,
    title: PropTypes.string,
    promotion: PropTypes.shape({
      creative: PropTypes.string,
    }),
  }),
}

export default Sponsor
